import React from "react";

import "./style.css";

export default function Footer() {
  return (
    <div className="footer-container">
      <p>&copy; 2020 by InteliDev</p>
    </div>
  );
}
